export default "__VITE_ASSET__DGTxxPNT__"